import TimestampTooltip from '@/components/atoms/TimestampTooltip/TimestampTooltip';

export const Time = ({ time, created }: { time: string; created?: string }) => {
  return (
    <TimestampTooltip timestamp={created ?? time} side="top">
      <span className="shrink-0 cursor-default text-sm leading-5 font-normal whitespace-nowrap text-muted-foreground select-none">
        {time}
      </span>
    </TimestampTooltip>
  );
};
